export const one = (
  <div className="dice first-face">
    <span className="dot"> </span>
  </div>
);
export const two = (
  <div className="dice second-face">
    <span className="dot"> </span>
    <span className="dot"> </span>
  </div>
);
export const three = (
  <div className="dice third-face">
    <span className="dot"> </span>
    <span className="dot"> </span>
    <span className="dot"> </span>
  </div>
);
export const four = (
  <div className="dice face">
    <div className="column">
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
    <div className="column">
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  </div>
);
export const five = (
  <div className="dice face">
    <div className="column">
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
    <div className="column mid">
      <span className="dot"></span>
    </div>
    <div className="column">
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  </div>
);
export const six = (
  <div className="dice face">
    <div className="column">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
    <div className="column">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  </div>
);
export const oneSmall = (
  <div className="small-dice first-face">
    <span className="small-dot"> </span>
  </div>
);
export const twoSmall = (
  <div className="small-dice second-face">
    <span className="small-dot"> </span>
    <span className="small-dot"> </span>
  </div>
);
export const threeSmall = (
  <div className="small-dice third-face">
    <span className="small-dot"> </span>
    <span className="small-dot"> </span>
    <span className="small-dot"> </span>
  </div>
);
export const fourSmall = (
  <div className="small-dice face">
    <div className="column">
      <span className="small-dot"></span>
      <span className="small-dot"></span>
    </div>
    <div className="column">
      <span className="small-dot"></span>
      <span className="small-dot"></span>
    </div>
  </div>
);
export const fiveSmall = (
  <div className="small-dice face">
    <div className="column">
      <span className="small-dot"></span>
      <span className="small-dot"></span>
    </div>
    <div className="column mid">
      <span className="small-dot"></span>
    </div>
    <div className="column">
      <span className="small-dot"></span>
      <span className="small-dot"></span>
    </div>
  </div>
);
export const sixSmall = (
  <div className="small-dice face">
    <div className="column">
      <span className="small-dot"></span>
      <span className="small-dot"></span>
      <span className="small-dot"></span>
    </div>
    <div className="column">
      <span className="small-dot"></span>
      <span className="small-dot"></span>
      <span className="small-dot"></span>
    </div>
  </div>
);
export const fiveLarge = (
  <div className="large-dice face">
    <div className="column">
      <span className="large-dot"></span>
      <span className="large-dot"></span>
    </div>
    <div className="column mid">
      <span className="large-dot"></span>
    </div>
    <div className="column">
      <span className="large-dot"></span>
      <span className="large-dot"></span>
    </div>
  </div>
);
